import React from 'react'
import PropTypes from 'prop-types'
import { CHARGING_POINT_MAP_SLUG_NAME } from 'commons/js/constants'
import { Copy } from '@elparking/components'

PlugName.propTypes = {
    plugSlug: PropTypes.string,
}

export function getPlugName (plugSlug) {
    return CHARGING_POINT_MAP_SLUG_NAME[plugSlug]
}

function PlugName ({plugSlug, ...restProps}) {
    return (
        <>
            <Copy {...restProps}>
                {getPlugName(plugSlug)}
            </Copy>
        </>
    )
}

export default PlugName
